/* eslint-disable react/require-default-props */
import React from 'react'

import geojson2svg from 'geojson-to-svg'

interface Coordinate {
  latitude?: number;
  longitude?: number;
  lat?: number;
  lng?: number;
}

export type MultiCoordinates = Coordinate[][];

interface TypesCordenates {
  coordinates: MultiCoordinates; 
  fill: string;
  fillOpacity?: number;
  className?: string;
}

const SvgAgrupados: React.FC<TypesCordenates> = (props) => {
  const { coordinates, fill = 'green', fillOpacity = 1, className } = props
  let features = []

  const multi = true;

  if (!coordinates || coordinates.length === 0) {
    features = [
      {
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: [0, 0],
        },
        properties: {
          thumb: 'basic',
        },
      },
    ]
  } 
  else if (multi) {
    let talhoesCoordenadas: any[] = []

    coordinates.forEach((talhao) => {
      let pontosTalhao = talhao
        .filter((e) => (e.latitude || e.lat) && (e.longitude || e.lng))
        .map((dados) => [
          parseFloat(String(dados.longitude || dados.lng)),
          parseFloat(String(dados.latitude || dados.lat)) * -1, // Inverter latitude para alinhar no SVG
        ])

      if (pontosTalhao.length > 0) {
        talhoesCoordenadas.push([pontosTalhao]) // Cada talhão deve ser um array separado
      }
    })

    features.push({
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: talhoesCoordenadas,
      },
      properties: {
        thumb: 'basic',
      },
    })
  } else {
    // let pontos = coordinates
    //   .filter((e: any) => (e.latitude || e.lat) && (e.longitude || e.lng))
    //   .map((item) => [
    //     Number(item.longitude || dados.lng),
    //     (Number(item.latitude || dados.lat) * -1),
    //   ])

    features = [
      {
        type: 'Feature',
        geometry: {
          type: 'Polygon',
          coordinates: [],
        },
        properties: {
          thumb: 'basic',
        },
      },
    ]
  }

  let svg
  if (!features.length) {
    svg = null
  } else {
    svg = geojson2svg()
      .type('thumb')
      .styles({
        basic: { fill, fillOpacity, strokeColor: '#ffffff' },
      })
      .data({
        type: 'FeatureCollection',
        features,
      })
      .render()
  }

  return (
    <svg
      style={{ maxWidth: '50px', maxHeight: '50px', marginRight: 0 }}
      dangerouslySetInnerHTML={{ __html: svg }}
      className={className ?? ''}
    />
  )
}


export default SvgAgrupados;